import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('payments', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getBanks: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('banks', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getSales: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('payable_sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getCurrencies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('currencies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getInitiated: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('payments', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        attachProof: (cntx, formData) => new Promise((resolve, reject) => {
            axios.post('payments/proof', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        bulkAttachProof: (cntx, formData) => new Promise((resolve, reject) => {
            axios.post('payments/proof/bulk', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`banks/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('payments_proof', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        createDeposit: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('deposits', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        updateDeposit: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`deposits/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        importPayments: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('import_payments', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
